// extracted by mini-css-extract-plugin
module.exports = {"overlay":"idt-changegroupoverlay_overlay__8et39","overlayContent":"idt-changegroupoverlay_overlaycontent__3-x-t"};